import { cn, hasMessage } from '@/lib/utils';
import {
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';

import {
  ChainlitContext,
  useChatMessages,
  useChatSession,
  useConfig
} from '@chainlit/react-client';

import { Markdown } from '@/components/Markdown';
import { useUISettings } from '@/hooks/useUISettings';

import Starters from './Starters';
import StopButton from './StopButton';

interface Props {
  // Props are no longer needed since MessageComposer moved to footer
}

export default function WelcomeScreen(props: Props) {
  const apiClient = useContext(ChainlitContext);
  const { config } = useConfig();
  const { chatProfile } = useChatSession();
  const { messages } = useChatMessages();
  const { settings } = useUISettings();
  const [isVisible, setIsVisible] = useState(false);

  const chatProfiles = config?.chatProfiles;

  const allowHtml = config?.features?.unsafe_allow_html;
  const latex = config?.features?.latex;
  
  // Get colors and titles from settings with fallback to defaults
  const gradientStart = settings?.colors?.headerGradientStart || '#152644';
  const gradientEnd = settings?.colors?.headerGradientEnd || '#5B9BD5';
  const welcomeTitle = settings?.titles?.welcomeTitle || "Hello, I'm A.V.A.";

  useEffect(() => {
    setIsVisible(true);
  }, []);
  const greeting = useMemo(() => {
    if (chatProfile && chatProfiles) {
      const currentChatProfile = chatProfiles.find(
        (cp) => cp.name === chatProfile
      );      if (currentChatProfile?.markdown_description) {        return (          <div className="flex flex-col gap-2 mb-4 items-center text-center px-4">
            <div className="flex flex-col gap-2 items-center">
              <h1 
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal"
                style={{ 
                  background: 'linear-gradient(90deg, rgba(22, 29, 37, .87) 0%, rgba(53, 70, 70, .87) 19.23%, rgba(16, 220, 158, .87) 100%)', 
                  WebkitBackgroundClip: 'text', 
                  WebkitTextFillColor: 'transparent', 
                  backgroundClip: 'text' 
                }}
              >
                Hello
              </h1>
              <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 px-4">
                How can I assist you today
              </p>
            </div>
            <Markdown allowHtml={allowHtml} latex={latex}>
              {currentChatProfile.markdown_description}
            </Markdown>
          </div>
        );
      }
    }    return (
      <div className="flex flex-col gap-2 items-center text-center mb-4 px-4">
        <h1 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal"
          style={{ 
            background: `linear-gradient(to right, ${gradientStart}, ${gradientEnd})`, 
            WebkitBackgroundClip: 'text', 
            WebkitTextFillColor: 'transparent', 
            backgroundClip: 'text' 
          }}
        >
          {welcomeTitle}
        </h1>
        <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 px-4">
          I'm your digital assistant at Signature, here to provide quick answers and assist with any of the topics shown below. Be cautious about sharing sensitive or confidential information. AI-generated content may be incorrect.
        </p>
      </div>
    );
  }, [chatProfiles, chatProfile, allowHtml, latex]);

  if (hasMessage(messages)) return null;  return (    <div
      id="welcome-screen"
      className={cn(
        'flex flex-col gap-4 w-full flex-grow items-center justify-center welcome-screen mx-auto transition-opacity duration-500 opacity-0 delay-100',
        // Mobile responsive styles
        '-mt-[40px] sm:-mt-[60px]',
        'px-4 sm:px-6 md:px-8',
        'max-w-full sm:max-w-3xl md:max-w-4xl',
        isVisible && 'opacity-100'      )}
    >
      {greeting}
      <StopButton />
      <Starters />
    </div>
  );
}
